import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { connect } from "react-redux";

import { setBalance } from "../../redux/actions/balanceActions";
import { setScamber } from "../../redux/actions/scamberActions";
import { setCart } from "../../redux/actions/cartActions";

import HeaderComponent, { Column, ColumnItem } from "../../components/patterns/header";
import { Logo } from "../../components/design/layout/logo";
import SearchForm, { SearchField, SubmitSearch } from "../../components/design/layout/search";

import logoImage from "../../assets/images/logo.png";
import Params from "../../services/Params";

function Header() {
    const history = useHistory();
    const param = new Params();
    
    const searchUrl = document.location.href;

    const [headerParams, setHeaderParams] = useState();

    const [searchVisibility, setSearchVisibility] = useState(true);

    useEffect(() => {

        param.findParam('header').then((response) => {
            if (response.data && response.data.type === 'success') {
                setHeaderParams(response.data.payload);
            }
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if (searchUrl.indexOf('ajuda') !== -1) {
            return setSearchVisibility(false);
        } else {
            return setSearchVisibility(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [param]);

    return (
        <>
            <HeaderComponent theme="atacadao">

                {headerParams && headerParams.mostrar_header ?
                    (<>
                        {headerParams.mostrar_logo ?
                            (<Column className="column-1">
                                <ColumnItem>
                                    <Logo link="/" image={logoImage} alt="Scamb" />
                                </ColumnItem>
                            </Column>) : (<></>)
                        }

                        {/* {searchVisibility && ()} */}

                        {searchVisibility && headerParams.mostrar_barra_busca ?
                            (<Column className="column-2">
                                <ColumnItem>
                                    <SearchForm>
                                        <SearchField
                                            placeholder={`Faça uma busca`}
                                            type="text"
                                            name="search"
                                            readOnly={true}
                                            onClick={() => history.push({ pathname: '/search', search: history.location.search })}
                                        />

                                        <SubmitSearch type="button" onClick={() => history.push({ pathname: '/search', search: history.location.search })} />
                                    </SearchForm>
                                </ColumnItem>
                            </Column>)
                            : (<></>)
                        }</>)
                    : (<></>)

                }
            </HeaderComponent>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        cart: state.cartReducer.cart,
        balance: state.balanceReducer.balance,
        site_properties: state.websiteReducer.site_properties,
        website: state.websiteReducer.website
    };
};

export default withRouter(
    connect(mapStateToProps, { setScamber, setBalance, setCart })(Header)
);